import { Action, ActionReducer } from '@ngrx/store';

import * as actions from '../actions/auth.actions';

/**
 * MetaReducer that resets to initial state after logging out
 * @param next The next metareducer to apply
 */
export function logoutReducer(next: Function): ActionReducer<any> {
  return (state: any, action: Action): any => {
    switch (action.type) {
      case actions.RESPONSE_SUCCESS_AUTH_LOGOUT:
        // This takes advantage of the fact that reducers supply an initial state
        // if called without the state passed in as a param
        return next(undefined, action);
      default:
        return next(state, action);
    }
  };
}
